import {
  Alert,
  Button,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  Label,
} from 'components';
import ComActionUploadFile from 'components/ComActionUploadFile';
import {Ecolors, Icons} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {ActivityIndicator, Platform} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {goBack, uploadFile, useImageUrl} from 'services';
import {apiEvent} from 'services/apis/apiEvent';

const ItemImage = (p: {
  data: any;
  removeImageFromList: (t: any) => void;
  index;
}) => {
  const w = 160;
  const h = 100;
  const {data, removeImageFromList, index} = p;
  const [imageSource] = useImageUrl(
    `download/file-for-link`,
    'POST',
    `${data.fileUrl}`,
  );

  if (data.isDelete) {
    return <></>;
  }
  return (
    <Div
      width={w}
      marginTop={10}
      marginRight={index % 2 == 0 ? 10 : 0}
      height={h}
      borderWidth={1}
      borderColor={Ecolors.bordercolor}
      borderStyle="dashed"
      borderRadius={8}
      overflow="hidden">
      <ImageView
        resizeMode={'center'}
        source={{
          uri: imageSource.url,
        }}
        width={w}
        height={h}
      />
    </Div>
  );
};

function ImageTransactionModal() {
  const bottomSheetUpload = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [listData, setListData] = useState<Array<any>>([]);
  const [listUsing, setListUsing] = useState<Array<any>>([]);
  const insets = useSafeAreaInsets();

  useEffect(() => {
    getListData();
    return () => {};
  }, []);

  const getListData = async () => {
    try {
      setLoading(true);
      const r = await apiEvent.loadEvidenceBankFile();
      if (r.status == 200) {
        setListData(r.data);
        setListUsing(r.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const doAction = async image => {
    try {
      setLoading(true);
      const res: any = await uploadFile({
        fileBase64: image.base64,
      });
      if (!!res) {
        const obj = {
          id: null,
          fileName: res.desFileName,
          fileType: {
            code: 'EVIDENCE_BANK_TRANSFER',
            id: 10,
            name: 'Bằng chứng chuyển khoản ngân hàng',
          },
          fileUrl: res.url,
          isDelete: false,
        };
        setListUsing(t => [...t, obj]);
        setListData(t => [...t, obj]);
      }
    } catch (error: any) {
      Alert.showError({
        content: 'alert.dungluongtoida',
      });
    } finally {
      setLoading(false);
    }
  };

  const onAccept = async () => {
    try {
      setLoading(true);
      const r = await apiEvent.uploadEvidenceBankFile(listData);
      Alert.show({
        content: 'alert.capnhathinhanhthanhcong',
        type: 2,
        titleConfirm: `alert.dong`,
        onClose: () => {
          goBack();
        },
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const removeImageFromList = (itemremove: any) => {
    setListUsing(t => t.filter((a: any) => a.fileUrl != itemremove.fileUrl));
    setListData(t =>
      t.map((item: any) => {
        if (item.fileUrl == itemremove.fileUrl) {
          return {...item, isDelete: true};
        }
        return item;
      }),
    );
  };

  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <ComActionUploadFile doAction={doAction} ref={bottomSheetUpload} />
      <HeaderBack type={2} title={`eventreward.uploadhinhanhgiaodich`} />
      <ScrollView showsVerticalScrollIndicator={false}>
        <Div padding={20}>
          <Div
            alignItems="center"
            justifyContent="center"
            width={335}
            height={330}
            borderRadius={10}
            borderStyle="dashed"
            borderWidth={0.8}
            borderColor={Ecolors.bordercolor}>
            {loading ? (
              <ActivityIndicator color={Ecolors.mainColor} size={'large'} />
            ) : (
              <Button
                alignItems="center"
                justifyContent="center"
                onPress={() => {
                  bottomSheetUpload.current.show();
                }}>
                <ImageView
                  source={Icons.camera}
                  widthHeight={40}
                  tintColor={Ecolors.mainColor}
                  resizeMode="contain"
                />
                <Label marginTop={2}>{`eventreward.taianhlen`}</Label>
              </Button>
            )}
          </Div>
          <Label
            marginVertical={18}
            fontWeight="700">{`eventreward.hinhanhdaupload`}</Label>
          <Div flexDirection="row" flexWrap="wrap">
            {listUsing.map((item: any, index: number) => {
              return (
                <Div key={item.fileUrl}>
                  <ItemImage
                    index={index}
                    removeImageFromList={removeImageFromList}
                    data={item}
                    key={item.fileUrl}
                  />
                </Div>
              );
            })}
          </Div>
        </Div>
      </ScrollView>
      <Div
        flexDirection={'row'}
        alignItems={'center'}
        marginTop={10}
        marginBottom={insets.bottom + 20}
        paddingHorizontal={29}
        justifyContent={'space-between'}
        width={'100%'}>
        <ButtonBorder
          onPress={() => {
            goBack();
          }}
          width={148}
          height={48}
          title={`createordermodal.quaylai`}
          type={2}
        />
        <ButtonBorder
          loading={loading}
          onPress={() => {
            onAccept();
          }}
          width={148}
          height={48}
          title={`createordermodal.xacnhan`}
          type={1}
        />
      </Div>
    </Div>
  );
}

export default React.memo(ImageTransactionModal);
